import { SectionName } from '../../../observability/tracking/events';
import { withTracking } from '../../../observability';
import { PlanComparisonSection } from './PlanComparisonSection';
import { createBuilderModule } from '../../../register-builder/builder-module';
import { COLOR_KEYS, ICON_NAMES } from '../../../constants';
import { PLANS } from './fixtures';

export default createBuilderModule(
  withTracking(PlanComparisonSection, {
    as: 'section',
    sectionName: SectionName.PlanComparisonSection,
  }),
  {
    name: 'PlanComparison',
    image: 'https://cdn.zappy.app/55d81bcc520563f6d24ab42ecfe75d87.png',
    inputs: [
      {
        name: 'title',
        type: 'string',

        required: true,
        defaultValue: 'A plan to fit your needs',
      },
      {
        name: 'backgroundColor',
        type: 'string',
        enum: [
          COLOR_KEYS.moss,
          COLOR_KEYS.neutral800,
          COLOR_KEYS.night,
          COLOR_KEYS.zapier,
        ],
        required: true,
        defaultValue: COLOR_KEYS.zapier,
      },
      {
        name: 'plans',
        type: 'list',
        defaultValue: PLANS,
        subFields: [
          { name: 'title', required: true, type: 'string' },
          {
            name: 'description',
            required: true,
            type: 'string',
          },
          {
            name: 'href',
            required: true,
            type: 'string',
            helperText: 'URL for CTA button',
          },
          {
            name: 'buttonText',
            required: true,
            type: 'string',
          },
          {
            name: 'iconName',
            type: 'string',
            enum: Object.values(ICON_NAMES),
            required: true,
          },
        ],
      },
    ],
  },
);
